module.exports = __webpack_public_path__ + "img/Cabin filter.3ef51f83.jpg";